<div *ngIf="errorMessage" class="file-browser-wrapper__empty-state">
    <span>{{errorMessage}}</span>
</div>
<div class="app-card" *ngIf="!errorMessage">
    <lib-file-browser 
        [treeData]="directoryData"
        [columnDefs]="columnDefs"
        (updateNode)="updateDirectory($event)"
        (onFileSelected)="onFileSelection($event)">
    </lib-file-browser>
</div>